import React from 'react';
import { motion } from 'framer-motion';
import { NeonButton } from './NeonButton';
import { Terminal, ShieldAlert } from 'lucide-react';
export function HeroSection() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative min-h-[90vh] flex items-center pt-10 pb-20 overflow-hidden" data-id="element-144">
      {/* Background Grid */}
      <div className="absolute inset-0 bg-[linear-gradient(rgba(57,255,20,0.03)_1px,transparent_1px),linear-gradient(90deg,rgba(57,255,20,0.03)_1px,transparent_1px)] bg-[size:40px_40px] [mask-image:radial-gradient(ellipse_60%_60%_at_50%_50%,#000_70%,transparent_100%)]" data-id="element-145"></div>

      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-146">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-147">
          {/* Text Content */}
          <motion.div initial={{
          opacity: 0,
          x: -50
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.8
        }} className="text-left" data-id="element-148">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full border border-cyber-purple/50 bg-cyber-purple/10 text-cyber-purple font-mono text-xs mb-6 shadow-neon-purple" data-id="element-149">
              <Terminal className="w-3 h-3" data-id="element-150" />
              <span data-id="element-151">SISTEMA_INICIADO // v1.0</span>
            </div>

            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight" data-id="element-152">
              Cómo Hackear tu{' '}
              <span className="text-cyber-neon text-shadow-neon" data-id="element-153">
                Ansiedad Social
              </span>{' '}
              y Dominar Cualquier Conversación en 30 Días
            </h1>

            <p className="text-xl text-gray-400 mb-4 font-mono border-l-2 border-cyber-neon pl-4" data-id="element-154">
              Sin Tener que "Fingir ser Extrovertido"
            </p>

            <p className="text-lg text-gray-300 mb-8 leading-relaxed" data-id="element-155">
              Incluso Si Hoy Sientes que Todos Te Juzgan y Te Escondes en el
              Celular para Evitar Saludar. El Protocolo de Micro-Exposición
              diseñado para la Gen Z que quiere recuperar su libertad social.
            </p>

            <div className="flex flex-col sm:flex-row gap-4" data-id="element-156">
              <NeonButton size="lg" onClick={scrollToPricing} data-id="element-157">
                INICIAR PROTOCOLO AHORA
              </NeonButton>
              <div className="flex items-center gap-2 text-xs text-gray-500 font-mono mt-2 sm:mt-0" data-id="element-158">
                <ShieldAlert className="w-4 h-4 text-cyber-neon" data-id="element-159" />
                <span data-id="element-160">Acceso Inmediato. Riesgo Cero.</span>
              </div>
            </div>
          </motion.div>

          {/* Product Image */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="relative" data-id="element-161">
            {/* Glow behind image */}
            <div className="absolute inset-0 bg-cyber-neon/20 blur-[100px] rounded-full" data-id="element-162"></div>

            <motion.img animate={{
            y: [0, -15, 0]
          }} transition={{
            duration: 6,
            repeat: Infinity,
            ease: 'easeInOut'
          }} src="https://cdn.magicpatterns.com/uploads/3XJEYGCu4jc1bEgF1GtnDk/heylloyd-image-1772901779611.png" alt="Social Hacker v1.0 en Tablet y Smartphone" className="relative z-10 w-full h-auto drop-shadow-[0_0_30px_rgba(57,255,20,0.3)]" data-id="element-163" />

            {/* Floating decorative elements */}
            <motion.div animate={{
            opacity: [0.5, 1, 0.5]
          }} transition={{
            duration: 2,
            repeat: Infinity
          }} className="absolute top-10 -right-4 bg-cyber-black border border-cyber-neon text-cyber-neon font-mono text-xs px-3 py-1 rounded shadow-neon z-20" data-id="element-164">
              [STATUS: ONLINE]
            </motion.div>
          </motion.div>
        </div>
      </div>
    </section>;
}